'use client'

import { AppErrorFallback } from '@/shared/ui'

interface IErrorProps {
  error: Error & { digest?: string }
  reset: () => void
}

const Error = ({ error, reset }: IErrorProps) => (
  <AppErrorFallback
    error={error}
    reset={reset}
    componentName='ReservationGroupError'
  />
)

export default Error
